import React from "react";
import Box from "@mui/material/Box";
// import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
// import Typography from "@mui/material/Typography";

import NewEventButton from "../NewEventButton/NewEventButton";
import FdTypography from "../UIComponents/Typography/FdTypography";
import FdCard from "../UIComponents/Card/FdCard";
import { noEvents as classes } from "./styles";

const NoEvents = () => {
  return (
    <Box sx={classes.mainBox}>
      <FdCard sx={classes.innerDiv}>
        <CardContent>
            <FdTypography label="Lets create your first event!" variant="h2" component="h2" align="center" />
            <FdTypography label="Please login to continue" sx={classes.paragraph} />
            <NewEventButton />
        </CardContent>
      </FdCard>
      <FdTypography label={<>No <br /> events <br />found!</>} sx={classes.message} />
    </Box>
  );
};

export default NoEvents;
